import { Autocomplete, TextField, Typography } from '@mui/material';
import customAxios from '../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GlobalVariables } from '../../globalVar';
import { getToast } from '../../utils/toastConfig';

function ModalDetailViewAssignTech(props) {
  var asignVisitClientName = props.clientName;
  var asignVisitSiteName = props.siteName;
  var asignVisitTypeName = props.visitTypeName;

  const [tech, setTech] = useState(null);

  function hide() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Técnico asignado exitosamente al servicio.',
    });
    setTimeout(() => {
      window.location.reload();
    }, 3600);
  }

  const assignTech = (tech) => {
    try {
      customAxios.patch(
        `${GlobalVariables.getURL()}assignTech/${props.visitId}`,
        {
          technical_id: tech.tech_id,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );
      getToast({ status: 'success', title: 'Técnico asignado exitosamente.' });
      props.setIsTechAssigned(true);
      window.location.reload();
    } catch (err) {}
  };

  const [freeTechs, setFreeTechs] = useState([]);

  // useEffect(() => {
  //     customAxios.get(`${GlobalVariables.getURL()}autofillTechs`, {
  //         headers: {
  //             'Authorization': 'bearer ' + localStorage.getItem('token')
  //         }
  //     })
  //         .then((response) => {
  //             setFreeTechs(response.data);
  //         })

  //         .catch(error => console.log(error));
  // }, []);

  return (
    <Modal
      {...props}
      size="m"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
      className="mui-modals-updated"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Asignar técnico
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="asign-tech-form">
          <div className="asign-tech-data">
            <div className="asign-tech-line">
              <Typography>
                <span style={{ color: 'gray', fontSize: '0.9em' }}>Plaza:</span>
              </Typography>
              <Typography>{asignVisitClientName}</Typography>
            </div>
            <div className="asign-tech-line">
              <Typography>
                <span style={{ color: 'gray', fontSize: '0.9em' }}>
                  Sucursal:
                </span>
              </Typography>
              <Typography>{asignVisitSiteName}</Typography>
            </div>
            <div className="asign-tech-line">
              <Typography>
                <span style={{ color: 'gray', fontSize: '0.9em' }}>
                  Tipo de servicio:
                </span>
              </Typography>
              <Typography>{asignVisitTypeName}</Typography>
            </div>
          </div>

          <br />

          <Autocomplete
            disablePortal
            options={props.freeTechs}
            sx={{ width: '100%' }}
            getOptionLabel={(freeTechs) => freeTechs.full_name}
            getOptionSelected={(freeTechs, value) => freeTechs.id === value.id}
            renderInput={(params) => (
              <TextField {...params} label="Seleccionar técnico..." />
            )}
            onChange={(event, newValue) => {
              setTech(newValue);
            }}
          />
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          form="asign-tech-form"
          className="save-modal-button"
          onClick={() => {
            assignTech(tech);
          }}
        >
          Guardar
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalDetailViewAssignTech;
